module.exports = __webpack_public_path__ + "static/media/cerrar_sesion.5d5f226e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/cerrar_sesion.svg
// module id = 1784
// module chunks = 0